module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/how_to_enjoy_photography_case5-638f0ede7490848379fd331a9bbd601a.jpg";